import type { Translation } from '../types.ts';
import type en from '../en/closure.ts';

export default {
    index: {
        title: 'Vakantiesluiting',
        intro: 'Wanneer {website} gesloten is voor vakantie.',
        noWebsite: 'Kies eerst een website om de vakantiesluiting ervan in te stellen.',
    },
    panel: {
        title: 'Vakantiesluiting',
        intro: 'Dagen waarop de winkel dicht is en er niets wordt ingepakt of verstuurd. {ordersKeepComing} de webwinkel toont in de winkelwagen en bij het afrekenen een melding op welke dag het pakket wordt verstuurd, en elke bestelling tijdens de sluiting krijgt die datum mee. Beide dagen tellen mee: dicht van 20 tot en met 27 juli betekent terug op de 28e. Vul beide datums in of geen van beide.',
        ordersKeepComing: 'Bestellingen blijven binnenkomen:',
        closedToday: 'Vandaag gesloten. Bestellingen van nu worden verstuurd vanaf {date}.',
        closing: 'Gesloten van {from} tot en met {until}, terug op {resumes}.',
        firstDay: 'Eerste dag gesloten',
        lastDay: 'Laatste dag gesloten',
        announceDays: 'Klanten zoveel dagen vooraf waarschuwen',
        announceHint: 'Hoe lang voor de sluiting de melding verschijnt. Twee weken past bij een winkel die pakketten verstuurt; een werkplaats die op bestelling maakt, neemt beter meer. {zero} zegt niets tot de winkel echt dicht is.',
        ownWording: 'Eigen tekst',
        ownWordingHint: '(laat leeg en wij schrijven de zin voor je)',
        defaultLocale: '(std)',
        messagePlaceholder: 'Bijv. De werkplaats is gesloten voor de inventarisatie.',
        clear: 'Sluiting wissen',
        save: 'Vakantiesluiting opslaan',
        saved: 'Vakantiesluiting opgeslagen',
    },
} satisfies Translation<typeof en>;
